import { i18nCore } from '@core-frontend/core-frontend';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { AppRoutes } from '@/app/app-router';

import { useMutate } from '@/shared/model/hooks';

import { resetPasswordConfirmAsync } from '../api';

export const useResetPasswordConfirmMutation = () => {
  const navigate = useNavigate();
  return useMutate(resetPasswordConfirmAsync, {
    onSuccess: () => {
      toast.success(
        i18nCore.t('common.Messages.Successfully.PasswordReset', {
          defaultValue: 'Password reset successfully',
        }),
        { position: 'top-center' }
      );
      navigate(AppRoutes.LOGIN);
    },
  });
};
